
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-orientation-program",
      function () {
        return require("private-next-pages/upsc-orientation-program/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-orientation-program"])
      });
    }
  